<template>
  <div class="login card">
    <h1>Sign in</h1><br>

    <div v-if="invitePending">
      <h4>Sign in and we'll get you added to the draft</h4>
      <br>
    </div>

    <form @submit.prevent="login">
      <input type="email" required placeholder="Email" v-model="loginForm.email">

      <input type="password" required placeholder="Password" v-model="loginForm.password"><br>

      <button type="submit" :disabled="running">Login</button><br><br>

      <div class="error" v-show="error">{{ error }}</div>

      <div>
        <span>You don't have an account?</span>

        <router-link to="/signup">
          Let's create one
        </router-link>
      </div><br>

      <div>
        <router-link to="/forgot">Forgot password?</router-link>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      loginForm: {
        email: '',
        password: '',
      },
      running: false,
      error: '',
    };
  },

  computed: {
    ...mapState({
      attemptedRoute: ({ auth }) => auth.attemptedRoute,
    }),

    invitePending() {
      return this.attemptedRoute && this.attemptedRoute.name === 'invite';
    },
  },

  methods: {
    login() {
      if (!this.running) {
        this.running = true;
        this.error = '';

        this.$firebase.auth()
          .signInWithEmailAndPassword(this.loginForm.email, this.loginForm.password)
          .then((user) => {
            this.$store.dispatch('auth/LOGIN', user)
              .then(() => {
                this.$router.push('/handleLogin');
              });
          })
          .catch((err) => {
            this.running = false;
            this.error = err.message;
          });
      }
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" type="text/scss" scoped>
  .login {
    @include centerContainer;
  }

  .error {
    margin-bottom: $gp;
  }
</style>
